import { useParams } from 'react-router-dom';
import { useGoToPath } from 'catering/hooks/navigation/useGoToPath';
import { buildMenuItemUpsellPath } from 'catering/helpers/paths';

export function useGoToMenuUpsellItem() {
  const { locationSlug } = useParams();
  const { go } = useGoToPath();
  return (menuItemSlug, isRedirect = false) =>
    go({
      path: buildMenuItemUpsellPath(locationSlug, menuItemSlug),
      isRedirect
    });
}
